import { OffersAndMetadata } from '@wwt/entities/search-response'

import { NavigationIndex } from '../types'

export const getOfferIndex = (
	offerId: string | null,
	pages: OffersAndMetadata[]
): NavigationIndex | null => {
	for (let pageIndex = 0; pageIndex < pages.length; pageIndex++) {
		const offerIndex = pages[pageIndex].offers.findIndex(
			offer => offer.IDs.nonPersistingOfferId === offerId
		)

		if (offerIndex !== -1) {
			return { pageIndex, offerIndex }
		}
	}

	return null
}
